import { memo } from 'react'
import { DeepNullable } from '../../utilities'

export type StrapiVideoData = null | DeepNullable<{
  mime: string
  localFile: {
    publicURL: string
  }
}>

type Props = {
  strapiVideo?: StrapiVideoData
  isRequired?: boolean
  className?: string
}

export const StrapiVideo = memo<Props>(
  ({ strapiVideo, className, isRequired = false }) => {
    if (strapiVideo?.localFile?.publicURL && strapiVideo?.mime) {
      return (
        <video className={className} controls muted>
          <source
            src={strapiVideo.localFile.publicURL}
            type={strapiVideo.mime}
          />
        </video>
      )
    }
    if (isRequired) {
      console.error(strapiVideo, JSON.stringify(strapiVideo, null, 2))
      throw new Error('Required video is missing: ')
    }
    return null
  },
)

StrapiVideo.displayName = 'StrapiVideo'
